/* unplugin-vue-components disabled */import { render } from "./HeaderBrand.vue?vue&type=template&id=2200e8bc"
import script from "./HeaderBrand.vue?vue&type=script&lang=js"
export * from "./HeaderBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__